// src/config/rockIcons.js
import rockImg    from "../../../assets/images/maps/rocks/rocknugget.png";
import goldImg    from "../../../assets/images/maps/rocks/goldnugget.png";
import emeraldImg from "../../../assets/images/maps/rocks/emeraldnugget.png";
import rubyImg    from "../../../assets/images/maps/rocks/rubynugget.png";
import diamondImg from "../../../assets/images/maps/rocks/diamondnugget.png";
import sapphireImg from "../../../assets/images/maps/rocks/sapphirenugget.png";

// Stone items (IDs 112, 34, 114, 126, 22, 26, 151, 135)
import fireStoneImg from "../../../assets/images/items/firestone.png";
import waterStoneImg from "../../../assets/images/items/waterstone.png";
import thunderStoneImg from "../../../assets/images/items/thunderstone.png";
import leafStoneImg from "../../../assets/images/items/leafstone.png";
import moonStoneImg from "../../../assets/images/items/moonstone.png";
import dawnStoneImg from "../../../assets/images/items/dawnstone.png";
import metalCoatImg from "../../../assets/images/items/metalcoat.png";
import kingsRockImg from "../../../assets/images/items/kingsrock.png";


export const rockIcons = {
  rock:    rockImg,
  gold:    goldImg,
  emerald: emeraldImg,
  ruby:    rubyImg,
  sapphire: sapphireImg,
  diamond: diamondImg,
  // Stone items
  fire_stone: fireStoneImg,
  water_stone: waterStoneImg,
  thunder_stone: thunderStoneImg,
  leaf_stone: leafStoneImg,
  moon_stone: moonStoneImg,
  dawn_stone: dawnStoneImg,
  metal_coat: metalCoatImg,
  kings_rock: kingsRockImg,
  // Stone items from ring 146 (mapping to their proper images)
  stone_112: fireStoneImg,    // Fire Stone
  stone_34: waterStoneImg,    // Water Stone
  stone_114: thunderStoneImg, // Thunder Stone
  stone_126: leafStoneImg,    // Lead Stone
  stone_22: moonStoneImg,     // Moon Stone
  stone_26: dawnStoneImg,     // Dawn Stone
  stone_151: metalCoatImg,    // Metal Coat
  stone_135: kingsRockImg,    // Kings Rock
};
